export const TITLE = "Cats List";
export const MALE = "Male";
export const FEMALE = "Female";
export const ANIMAL_TYPE = "Cat";